import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberintLogoSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 20,
	viewBox: "3 7 24 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "small icons",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.1252 12.5879L19.148 12.6542H16.8025L16.7882 12.6254C15.4383 9.89226 12.3162 8.56078 9.43414 9.48917C6.5521 10.4176 4.7709 13.3285 5.23863 16.3458C5.70637 19.3631 8.28334 21.5856 11.3085 21.5807C13.6342 21.5583 15.751 20.2213 16.7882 18.1197L16.8025 18.0909H19.148L19.1252 18.1572C17.949 21.5004 14.8229 23.7405 11.3085 23.7583C7.08665 23.7626 3.53428 20.5667 3.05435 16.3322C2.57442 12.0977 5.3199 8.17432 9.43365 7.21587C13.5474 6.25741 17.7184 8.56938 19.1252 12.5879ZM22.8296 12.6597H25.1023V23.6984H22.8296V12.6597ZM23.9155 10.54C25.694 10.54 27.1771 9.16708 27.331 7.37842H20.5C20.6539 9.16708 22.137 10.54 23.9155 10.54Z"
		})
	})
});
export default SvgCyberintLogoSmall;
